// extracted by mini-css-extract-plugin
export default {"loaderContainer":"StartSlideV19Experiment_loaderContainer-XOx"};